import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Globals} from '../globals';
import {TsaService} from '../_services/tsa.service';
import 'chartjs-plugin-colorschemes'; // https://nagix.github.io/chartjs-plugin-colorschemes/colorchart.html
import {UIChart} from 'primeng/chart';

@Component({
  selector: 'app-comparison',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.css']
})
export class ComparisonComponent implements OnInit {
  @Input() params: string = '';
  @Input() lineCode: string = '';
  @Input() airports: string = '';
  @Input() latestActual: string = '';
  @Input() chartOptions: any;
  @Input() interval: number = 7;
  @Output() dataEvent = new EventEmitter<any>();
  @ViewChild('chart') chart: UIChart | undefined;
  chartWidth = '90vw';
  chartHeight = '65vh';
  cmpData: any;
  loading = false;

  constructor(private service: TsaService,
              private globals: Globals,) {
  }

  ngOnInit(): void {
    if (this.lineCode == "BENCHMARK") {
      this.updateService('/Query.action?sql=SQL_TSA_' + this.lineCode + this.params);
    } else {
      this.updateService('/Query.action?sql=SQL_TSA_AIRPORT_TRAFFIC' + this.lineCode + this.params);
    }
  }

  /**
   * Refresh data for the comparison chart
   * @param url - URL for getting the data
   */
  updateService(url: string): void {
    this.service.url = url;
    this.loading = true;
    this.service.getData().subscribe((data: any[]) => {
      this.loading = false;
      this.dataEvent.emit(data);

      let apts0 = this.airports.split(',');
      let apts = [];
      if(url.indexOf('BENCHMARK')>0) apts.push('US');  // Show US total first
      if(this.airports.length > 0) {
        for (let i = 0; i < apts0.length; i++) {
          apts.push(apts0[i]);
        }
      }
      const x = [];
      const y: any[] = [];
      const est: any[] = [];
      for(let i=0; i<apts.length; i++) {
        y.push(new Array());
        est.push(new Array());
      }

      for (let item of data) {
        x.push(item.DATE);
        let cutoffDate = this.latestActual;
        if(item.DATE >= cutoffDate) {
          for(let i=0; i<apts.length; i++) {
            est[i].push(item[apts[i]]);
          }
          // Add one point to connect two lines
          if(item.DATE > cutoffDate) {
            for(let i=0; i<apts.length; i++) {
              y[i].push(null);
            }
          } else {
            for(let i=0; i<apts.length; i++) {
              y[i].push(item[apts[i]]);
            }
          }
        } else {
          for(let i=0; i<apts.length; i++) {
            let value = item[apts[i]];
            // if (!value) value = 0;  // Set value to zero if null
            y[i].push(value);
            est[i].push(null);
          }
        }
      }

      let ds = [];
      for(let i=0; i<apts.length; i++) {
        ds.push({
          label: apts[i],
          fill: false,
          data: y[i]
        })
      }
      for(let i=0; i<apts.length; i++) {
        //let degree = Math.round((i+2) * 256 / (apts.length+2));
        let color = this.globals.getColor(i);
        ds.push({
          label: 'Forecast ' + apts[i],
          borderColor: color, //'rgba(' + degree + ',' + degree + ',' + degree + ',1)',
          pointBorderColor: color,
          pointBackgroundColor: color,
          pointHoverBorderColor: color,
          pointHoverBackgroundColor: color,
          fill: false,
          data: est[i]
        })
      }

      this.cmpData = {
        labels: x,
        datasets: ds
      };

      // Show points when there are less than 10 data points. Otherwise, single day data won't display.
      this.globals.dataPoints(this.chart, x.length);
    });
  }


  /**
   * Enable or disable zoom and pan function
   */
  changeZoomPan() {
    if(this.chart) {
      this.chart.options.plugins.zoom.zoom.enabled = !this.chart.options.plugins.zoom.zoom.enabled;
      this.chart.options.plugins.zoom.pan.enabled = !this.chart.options.plugins.zoom.pan.enabled;
      this.chart.options.plugins.zoom.zoom.speed = 0.00005 * this.interval;
      this.chart.reinit();
    }
  }
}
